import React from 'react';
import './circleviewcta.css'

const Circlenav = ({ onClick ,icon ,alt  }) => {
    return ( 
        <button className='circle-cta'  onClick={onClick}>
            <img className='arrroww' src={icon} alt='alt'></img>
        </button>
     );
}
 
export default Circlenav;